import {
  ContentDisplayState,
  ContentDisplayLoadingStatus,
  ContentActionTypes,
  LOADED_TRENDING_TOPICS,
  LOADING_TRENDING_TOPICS,
  SAVED_TRENDING_TOPIC,
} from './types';
import { DELETED_SAVED_ITEMS } from '../saveditems/types';
import { SavedItemActionTypes } from '../saveditems/types';
import { TopicViewModel } from '../../model/topic/types';

const initialState = {
  status: ContentDisplayLoadingStatus.Uninitialized,
  trendingTopics: [] as TopicViewModel[],
};

const reducer = (
  state: ContentDisplayState = initialState,
  action: ContentActionTypes | SavedItemActionTypes
): ContentDisplayState => {
  switch (action.type) {
    case LOADING_TRENDING_TOPICS: {
      return {
        ...state,
        status: ContentDisplayLoadingStatus.Loading,
      };
    }

    case LOADED_TRENDING_TOPICS: {
      return {
        ...state,
        trendingTopics: action.payload,
        status: ContentDisplayLoadingStatus.Loaded,
      };
    }

    case SAVED_TRENDING_TOPIC: {
      return {
        ...state,
        trendingTopics: state.trendingTopics.filter(
          (x) => x.termSetMapId !== action.payload.termSetMapId
        ),
      };
    }
    case DELETED_SAVED_ITEMS: {
      return initialState;
    }
  }
  return state;
};

export default reducer;
